// @flow

import _ from 'lodash';

const TEN_MS = 10;

const asyncCall = (callback: Function, value: number = TEN_MS) => _.delay(callback, value);
const asyncCallFp = (callback: Function, value: number = TEN_MS) => () => _.delay(callback, value);

export {
	asyncCall,
	asyncCallFp,
};
